// import {
//   UPDATE_CONFIG_APP
// } from '../mutation-types.js'
// import { assign } from '../../common/utils.js';

export default {

}
